import React from 'react';
import './about.scss'
const About = () => {
    return (
        <div className="about-organisms container" id="about">
            <div className="text-center">
                <h2 className="heading-section text-uppercase">About</h2>
            </div>
            <div className="description-section text-center ">
            Hi, Im a fresh graduated from Telkom University with strong passion to learn new things.
                    Im familiar with some laravel framework, and i have developed API using Express.
                    Currently i am interested learning about ReactJS framework. Besides, i love to play musical instruments such as guitars. Thank you for visiting my website.
            </div>
        </div>
    );
};

export default About;